import { Component, ViewChild, ElementRef, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { Observable, from } from 'rxjs';
import { PageBreadcrumbComponent, BreadcrumbItem } from "../../shared/components/common/page-breadcrumb/page-breadcrumb.component";
import { CommonModule, formatDate } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { AdministrationService } from '../../services/administration/administration.service';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../../lib/app.constant';
import { ReactiveFormsModule, Validators, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MasterdataService } from '../../services/master-data/masterdata.service';
import { Router } from '@angular/router';
import { MessageService, MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { of } from 'rxjs';
import { HighlightPipe } from '../../shared/pipe/highlight.pipe';
import { MarkdownComponent } from 'ngx-markdown';
import { AppDatePipe } from '../../shared/pipe/app-date.pipe';
import { StatusColorService } from '../../services/status-color/status-color.service';
import { catchError, concatMap, debounceTime, distinctUntilChanged, map, switchMap, finalize, toArray } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonService } from '../../services/common/common.service';
import { SidebarService } from '../../shared/services/sidebar.service';
interface AttemptInfo {
  attempt: number;
  log_count: number;
  started_on?: string | null;
  ended_on?: string | null;
  status?: string | null;
  trigger?: string | null;
  triggered_by?: string | null;
}
interface PayloadNode {
  key: string;
  path: string;
  depth: number;
  type: 'object' | 'array' | 'string' | 'number' | 'boolean' | 'null';
  value?: unknown;
  children?: PayloadNode[];
  count?: number;
}
@Component({
  selector: 'app-document-tracker',
  imports: [
    AppDatePipe,
    PageBreadcrumbComponent,
    CommonModule,
    FormsModule,
    SelectModule,
    MultiSelectModule,
    DatePickerModule,
    DragDropModule,
    TooltipModule,
    ToastModule, InputTextModule, InputIconModule, IconFieldModule, HighlightPipe, CheckboxModule, ReactiveFormsModule,
    MenuModule, ToggleSwitchModule, ButtonModule, DialogModule, MarkdownComponent
  ],
  templateUrl: './document-tracker.component.html',
  styleUrl: './document-tracker.component.css',
})

export class DocumentTrackerComponent implements OnInit, OnDestroy {
  @ViewChild('filterSearch') filterSearch: any;
  @ViewChild('inputfileContainer') inContainer!: ElementRef;
  @ViewChild('outputfileContainer') outContainer!: ElementRef;
  @ViewChild('p_datafileContainer') pdContainer!: ElementRef;
  @ViewChild('ackContainer') ackContainer!: ElementRef;
  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('bulkActionMenu') bulkActionMenu: any;
  @ViewChild('rowActionMenu') rowActionMenu: any;
  @Output() readonly searched = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();
  searchSubject = new Subject<string>();
  bulkActionMenuItems: MenuItem[] = [];
  actionMenuItems: MenuItem[] = [];
  isUploading: boolean = false;
  showSendEmailModal = false;
  selectedEmailRow: any = null;
  selectedEmailRowId: number | null = null;
  selectedEmailRowData: any = null;
  emailTemplates: any[] = [];
  loadingTemplates = false;
  activeMenuRow: any = null;
  isExpanded = false;
  selectAll = false;
  searchValue = '';
  serchInput: any = '';
  isFilterLoading = false;
  order_by: string = 'created_on';
  order_type = 1;
  showLogModal = false;
  documentLogs: any[] = [];
  groupedLogs: Record<number, any[]> = {}; // attempt -> logs
  attempts: AttemptInfo[] = [];
  selectedAttempt: number | null = null;
  tabStart = 0;
  isLogsLoading = false;
  showJsonModal = false;
  inputFileType: string = 'txt';
  outputFileType: string = 'txt';
  acknowledgeFileType: string = 'txt';
  selectedJsonData: any = null;
  processedView: 'structured' | 'raw' = 'structured';
  private readonly structuredCache = { text: '', search: '', rows: null as { key: string; value: unknown }[] | null };
  private payloadCache = { text: '', search: '', nodes: null as PayloadNode[] | null };
  private readonly PAYLOAD_INITIAL_EXPAND_DEPTH = 1;
  expandedPayloadPaths = new Set<string>();
  copiedPayloadPath: string | null = null;
  private payloadCopyTimer: any = null;
  selectedDocId: number | null = null;
  selectedErrorLog: any = null;
  aiExplanation: string | null = null;
  isAiLoading = false;
  aiErrorMessage: string | null = null;
  aiCopied = false;
  showColumnSettings: any = false
  inputFile: any = null;
  outputFile: any = null;
  isFilterOpen = false;
  column_list: any | undefined;
  dropdown_list: any;
  filterable_columns: any[] = [];
  filterModel: any = {};
  isInputFileModalVisible = false;
  inputFileContent: string = '';
  isFileLoading = false;
  isOutputFileModalVisible: boolean = false;
  isOutputFileLoading: boolean = false;
  outputFileContent: string = '';
  isAcknowledegeModalVisible: boolean = false;
  isAcknowledegeLoading: boolean = false;
  acknowledegeFileConent: string = '';
  isTableLoading: boolean = false;
  selectedOutputFileName: any
  selectedOutputFileFormatName: any;
  rowData: any = null;
  customerId: any
  searchText = '';
  matchCount = 0;
  outSearchText = '';
  outMatchCount = 0;
  pd_SearchText = '';
  pd_MatchCount = 0;
  ackSearchText = '';
  ackMatchCount = 0;
  currentPage: number = 1;
  pageSize: number = 25;
  totalCount: number = 0;
  privileges: any[];
  acknowledgementStatus: any = null;
  slaFilter: any = null;
  correlationKey: string | null = null;
  correlationValue: string | null = null;
  allColumns: any[] = [];
  tableData: any[] = [];
  itemsPerPage = 25;
  showUploadModal = false;
  selectedUploadFiles: File[] = [];
  uploadFileStatuses: Array<'pending' | 'uploading' | 'done' | 'failed'> = [];
  uploadFileErrors: Array<string | null> = [];
  uploadValidationError = '';
  uploadSummary: string | null = null;
  uploadCompletedCount = 0;
  previewIndex: number | null = null;
  previewText = '';
  previewLoading = false;
  previewTruncated = false;
  previewError: string | null = null;
  uploadDragOver = false;
  readonly uploadAcceptExts = ['.csv', '.json', '.xml', '.pff', '.edi'];
  readonly uploadMaxBytes = 2 * 1024 * 1024;
  selectedWFID: any = null;
  // Set when the row is a derived workflow created for another matching
  // partner contract: the upload it came from, for the back-link in the modal.
  selectedParentWFID: string | null = null;
  selectedParentDocId: number | null = null;
  showNavigationModal = false;
  navigationModalTitle = '';
  navigationModalMessage = '';
  today: Date = new Date();
  userId: any;
  selectedFiles: File[] = [];
  maxFiles = 5;
  fileError = '';
  showRemarkModal = false;
  remarkText = '';
  remarkRow: any = null;
  remarkEvent: number | null = null;
  loading = false;
  isSendingEmail: boolean = false;
  isProceeding: boolean = false;
  isSubmittingRemark = false;
  selectedEmailDocumentIds: number[] = [];
  bulkEmailDocumentIds: number[] = [];
  autoRefreshInterval = 0;
  refreshInSeconds: number | null = null;
  showAutoRefreshModal = false;
  readonly visibleTabCount = 3;
  readonly StatusEvent = Settings.StatusEvent;
  readonly Settings = Settings;
  readonly pageSizeOptions = Settings.GridConfiguration.pageSizeOptions;
  private autoRefreshTimer: ReturnType<typeof setInterval> | null = null;
  private aiCopyTimer: any = null;
  private readonly DROPDOWN_CACHE_TTL_MS = 5 * 60 * 1000;
  private pendingDocumentIds: number[] = [];
  private readonly FROZEN_KEYS = ['status', 'wfid'];
  private readonly DRAGGABLE_LOCKED_KEYS = ['sender_id', 'receiver_id'];
  private get ALL_LOCKED_KEYS(): string[] {
    return [
      ...this.FROZEN_KEYS,
      ...this.DRAGGABLE_LOCKED_KEYS
    ];
  }
  private readonly REMARK_REQUIRED_EVENTS = [
    Settings.StatusEvent.DISCARD,
    Settings.StatusEvent.MARK_COMPLETE,
  ];
  // MARK: - Auto-refresh
  readonly autoRefreshOptions = [
    { label: 'Disabled', value: 0 },
    { label: 'Every 3 secs', value: 3 },
    { label: 'Every 5 secs', value: 5 },
    { label: 'Every 10 secs', value: 10 },
    { label: 'Every 15 secs', value: 15 },
    { label: 'Every 30 secs', value: 30 },
    { label: 'Every 60 secs', value: 60 },
  ];
  breadcrumbs: BreadcrumbItem[] = [
    { label: 'Document Tracker' }
  ];
  slaFilterOptions = [
    { label: 'Within SLA', value: 'Within SLA', },
    { label: 'Exceeded SLA', value: 'Exceeded SLA' }
  ];
  acknowledgementStatusOptions = [
    { label: 'ACCEPTED', value: 'ACCEPTED' },
    { label: 'REJECTED', value: 'REJECTED' },
  ];

  sendEmailForm = new FormGroup({
    use_template: new FormControl(false),
    template_id: new FormControl<number | string | null>(null),
    to: new FormControl('', [Validators.required, Validators.email]),
    cc: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', Validators.required),
    body: new FormControl('', Validators.required),
    is_attachment_send: new FormControl(false)
  });

  constructor(private readonly http: HttpClient,
    private readonly adminService: AdministrationService,
    private readonly masterDataService: MasterdataService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly host: ElementRef,
    public readonly statusColorService: StatusColorService,
    private readonly commonService: CommonService,
    private readonly sidebarService: SidebarService
  ) {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    this.customerId = userDetails?.customer_id
    this.privileges = userDetails?.privileges || [];
    this.userId = userDetails?.id;
  }

  get totalPages(): number {
    return Math.ceil(this.totalCount / this.itemsPerPage);
  }

  get currentItems(): any[] | undefined {
    return this.tableData;
  }
  get isRemarkRequired(): boolean {
    return this.remarkEvent != null && this.REMARK_REQUIRED_EVENTS.includes(this.remarkEvent);
  }

  // drives the Proceed button's disabled state
  get isProceedDisabled(): boolean {
    if (this.loading) return true;
    return this.isRemarkRequired && !this.remarkText.trim();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.loadTrackerList(page);
  }

  getVisiblePages(): number[] {
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    const end = Math.min(this.totalPages, start + maxVisible - 1);
    start = Math.max(1, end - maxVisible + 1);
    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  getStartRecord(): number {
    if (this.totalCount === 0) {
      return 0;
    }
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndRecord(): number {
    return Math.min(
      this.currentPage * this.itemsPerPage,
      this.totalCount
    );
  }

  getBadgeColor(status: string): 'success' | 'warning' | 'error' {
    if (status === 'Success') return 'success';
    if (status === 'Pending') return 'warning';
    return 'error';
  }

  getColumnSettings() {
    let body = {
      module_id: Settings.Module.DOCUMENT_TRACKER,
      // customer_id: this.customerId,
      user_id: this.userId
    };
    this.adminService.getColumnSettingsList(body).subscribe({
      next: (res: any) => {
        this.allColumns = (res?.results || [])
          .sort(
            (a: any, b: any) =>
              (a.sorting_order ?? 0) -
              (b.sorting_order ?? 0)
          )
          .map((el: any) => ({
            ...el,
            width: this.adminService.getColumnWidthPx(el.width),
            is_locked: this.isColumnLocked(el)
          }));
        this.column_list =
          this.allColumns.filter(col => col.is_visible && col.is_selected);
        this.filterable_columns =
          this.column_list.filter(
            (col: any) => col.is_filterable
          );
        // Warm filter caches in the background so opening the drawer is
        // usually a cache hit. Silent: never touches loader flags.
        this.assignStaticFilterOptions();
        this.ensureFilterOptions();
      },
      error: () => { }
    });
  }

  get frozenColumns() {
    return this.allColumns.filter(col =>
      this.FROZEN_KEYS.includes(col.key)
    );
  }

  getCellTooltip(row: any, col: any): string {
    const value = row?.[col?.key];
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (['document_source_url', 'out_doc_source_url', 'ack_source_url', 'acknowledgement_status'].includes(col?.key)) {
      return '';
    }
    if (['created_on', 'modified_on', 'document_date', 'received_date', 'processed_date'].includes(col?.key)) {
      try {
        return formatDate(value, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      } catch {
        return String(value);
      }
    }
    if (typeof value === 'object') {
      return value.name || value.label || JSON.stringify(value);
    }
    return String(value);
  }

  get normalColumns() {
    return this.allColumns.filter(col =>
      !this.FROZEN_KEYS.includes(col.key)
    );
  }

  getStatusBadgeClass(status: string): string {
    const normalizedStatus = status?.toLowerCase();
    switch (normalizedStatus) {
      case 'received':
        return 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-400';
      case 'in progress':
        return 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400';
      case 'sending to destination':
        return 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-400';
      case 'waiting for ack':
        return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-400';
      case 'successful':
      case 'completed':
        return 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400';
      case 'error':
        return 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400';
      default:
        return 'bg-gray-100 text-gray-700 dark:bg-gray-900/40 dark:text-gray-400';
    }
  }

  loadTrackerList(page: number = 1, isRefresh: boolean = false) {
    let filterData = { ...this.filterModel };
    if (filterData.created_on && filterData.created_on.length === 2) {
      filterData.created_on_start_date = this.formatDate(filterData.created_on[0]);
      filterData.created_on_end_date = this.formatDate(filterData.created_on[1]);
      delete filterData.created_on;
    }
    const preparedFilter = this.getPreparedDocTrackerFilter(filterData);
    const orderType = this.order_type === 1 ? 'desc' : 'asc';
    const body: any = {
      // customer_id: this.customerId,
      module_id: Settings.Module.DOCUMENT_TRACKER,
      export: false,
      order_by: this.order_by,
      order_type: orderType,
      page,
      page_size: this.itemsPerPage,
      ...preparedFilter
    };
    const searchText = this.searchValue?.trim();
    if (searchText) {
      body['search'] = searchText;
    }
    if (isRefresh) {
      this.isTableLoading = true;
    } else {
      this.loading = true;
    }
    this.adminService.getLoggerList(body, false).subscribe({
      next: (response: any) => {
        this.isTableLoading = false;
        this.loading = false;
        this.tableData = response?.results || [];
        this.totalCount = response?.count ?? this.tableData.length;
        this.currentPage = page;
      },
      error: () => {
        this.loading = false;
        this.isTableLoading = false;
        this.tableData = [];
        this.totalCount = 0;
      }
    });
  }

  onPageSizeChange() {
    this.currentPage = 1;
    this.loadTrackerList(1);
  }

  showNavigationError(type: string, name?: string) {
    this.navigationModalTitle = 'Navigation Unavailable';
    this.navigationModalMessage =
      `${type}${name ? ` "${name}"` : ''} could not be found.`;
    this.showNavigationModal = true;
  }

  openMap(row: any) {
    if (!row.map_id) {
      this.showNavigationError('Map', row.map_name);
      return;
    }
    this.router.navigate(
      ['/map/library'], {
      queryParams: { map_id: row.map_id },
      state: { fromDocTracker: true }
    }
    );
  }

  openConnectivity(row: any) {
    if (!row.contract_id) {
      this.showNavigationError(
        'Contract',
        row.tp_profile_contract
      );
      return;
    }
    this.router.navigate(
      ['/partners/contract'],
      {
        queryParams: { contract_id: row.contract_id },
        state: { fromDocTracker: true }
      }
    );
  }

  openSourceProfile(row: any) {
    if (!row.connectivity_id) {
      this.showNavigationError(
        'Source Connectivity Profile',
        row.source_connectivity_profile
      );
      return;
    }
    this.router.navigate(
      ['/partners/connectivity'],
      {
        queryParams: { connectivity_id: row.connectivity_id },
        state: { fromDocTracker: true }
      }
    );
  }

  openDestinationProfile(row: any) {
    if (!row.connectivity_dest_id) {
      this.showNavigationError(
        'Destination Connectivity Profile',
        row.destination_connectivity_profile
      );
      return;
    }
    this.router.navigate(
      ['/partners/connectivity'],
      {
        queryParams: { connectivity_dest_id: row.connectivity_dest_id },
        state: { fromDocTracker: true }
      }
    );
  }

  formatDate(date: Date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  refreshTable() {
    this.loadTrackerList(this.currentPage, true);
  }

  onAutoRefreshChange(seconds: number): void {
    this.stopAutoRefresh();
    this.autoRefreshInterval = Number(seconds) || 0;
    if (this.autoRefreshInterval > 0) {
      this.refreshInSeconds = this.autoRefreshInterval;
      this.messageService.add({
        severity: 'success',
        summary: 'Auto-refresh enabled',
        detail: `Document list will refresh every ${this.autoRefreshInterval} secs`,
        life: 3000,
      });
      // One-second ticker  held (not lost) while a load is in flight or
      // the tab is hidden, so refreshes never overlap or poll in the
      // background.drives both the countdown display and the
      // refresh. Ticks are
      this.autoRefreshTimer = setInterval(() => {
        if (document.hidden || this.loading || this.isTableLoading) {
          return;
        }
        this.refreshInSeconds = (this.refreshInSeconds ?? this.autoRefreshInterval) - 1;
        if (this.refreshInSeconds <= 0) {
          this.refreshTable();
          this.refreshInSeconds = this.autoRefreshInterval;
        }
      }, 1000);
    } else {
      this.refreshInSeconds = null;
      this.messageService.add({
        severity: 'info',
        summary: 'Auto-refresh disabled',
        detail: 'Automatic list refresh is turned off',
        life: 3000,
      });
    }
  }

  private stopAutoRefresh(): void {
    if (this.autoRefreshTimer !== null) {
      clearInterval(this.autoRefreshTimer);
      this.autoRefreshTimer = null;
    }
  }

  private getPreparedDocTrackerFilter(filterData: any) {
    const arrayConverted = this.convertFilterToArray(filterData);
    const preparedFilter = this.adminService.preparePayload(arrayConverted);
    if (this.acknowledgementStatus) {
      preparedFilter.acknowledgement_status = [this.acknowledgementStatus];
    }
    if (this.slaFilter) {
      preparedFilter.sla_exceeded = [this.slaFilter];
    }
    const correlationKey = this.correlationKey?.trim();
    if (correlationKey) {
      preparedFilter.reference_key = correlationKey;
    }
    const correlationValue = this.correlationValue?.trim();
    if (correlationValue) {
      preparedFilter.reference_value = correlationValue;
    }
    return preparedFilter;
  }

  applyFilters() {
    this.loadTrackerList(1);
    this.closeFilter();
  }

  onClickExport() {
    this.downloadExportFile();
  }

  downloadExportFile() {
    const filterData: any = {};
    const preparedFilter = this.getPreparedDocTrackerFilter(filterData);
    let body: any = {
      module_id: Settings.Module.DOCUMENT_TRACKER,
      export: true,
      order_by: this.order_by,
      order_type: this.order_type === 1 ? 'desc' : 'asc',
      page: 1,
      page_size: 150,
      ...preparedFilter
    };
    this.loading = true;
    this.adminService.getLoggerList(body, true).subscribe({
      next: (res: any) => {
        const blob = res.body;
        this.commonService.downloadFile(blob, 'document_tracker_list', 'xlsx');
        // this.loaderService.hide();
        this.loading = false;
        this.sidebarService.updateNotify.next(true);
      },
      error: () => {
        // this.loaderService.hide();
        this.loading = false;
      }
    });
  }

  openColumnSettingsModal() {
    this.showColumnSettings = true
  }

  convertFilterToArray(model: any) {
    const payload: any = {};
    Object.keys(model).forEach(key => {
      const value = model[key];
      if (
        value === null ||
        value === '' ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return;
      }
      if (key === 'is_valid') {
        payload[key] = value;
        return;
      }
      if (key.includes('_start_date') || key.includes('_end_date')) {
        payload[key] = value;
        return;
      }
      payload[key] = Array.isArray(value) ? value : [value];
    });
    return payload;
  }

  isColumnLocked(col: any): boolean {
    if (this.ALL_LOCKED_KEYS.includes(col.key)) {
      return true;
    }
    if (col.is_required || col.is_core) {
      return true;
    }
    return false;
  }

  toggleColumn(col: any) {
    if (this.isColumnLocked(col)) {
      return;
    }
    col.is_visible = !col.is_visible;
    col.is_selected = col.is_visible;
    this.column_list =
      this.allColumns.filter(c => c.is_visible);
    this.filterable_columns =
      this.column_list.filter(
        (c: any) => c.is_filterable
      );
  }

  trackByColumn(index: number, col: any): string {
    return col.key || col.id;
  }

  // drag drop logic
  drop(event: CdkDragDrop<{ label: string;[key: string]: any }[]>) {
    const droppedList = event.container.data;
    moveItemInArray(
      droppedList,
      event.previousIndex,
      event.currentIndex
    );
    const frozenCols =
      this.allColumns.filter(col =>
        this.FROZEN_KEYS.includes(col.key)
      );
    this.allColumns = [
      ...frozenCols,
      ...droppedList
    ];
    this.column_list =
      this.allColumns.filter(col => col.is_visible);
  }

  // Reset Column Settings
  resetColumns() {
    this.getColumnSettings();
  }

  isDraggableLocked(col: any): boolean {
    return this.DRAGGABLE_LOCKED_KEYS.includes(col.key);
  }

  saveColumns() {
    const mergedList = [
      ...this.frozenColumns,
      ...this.normalColumns
    ];
    const payload = mergedList.map(
      (
        {
          user_id,
          is_locked,
          order,
          sorting_order,
          ...col
        }: any,
        index: number
      ) => {
        const isFrozen =
          this.FROZEN_KEYS.includes(col.key);
        const isLocked =
          isFrozen ||
          this.DRAGGABLE_LOCKED_KEYS.includes(col.key);
        return {
          ...col,
          sorting_order: index,
          is_selected: isLocked
            ? true
            : col.is_selected,
          is_visible: isLocked
            ? true
            : col.is_visible
        };
      }
    );
    const body = {
      payload,
      module_id: Settings.Module.DOCUMENT_TRACKER,
      user_id: this.userId
    };
    this.adminService
      .postUserColumnSettings(body)
      .subscribe({
        next: (res: any) => {
          this.closeColumnSetting();
          this.getColumnSettings();

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail:
              res?.message ||
              'Column Settings Saved Successfully'
          });
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              err?.error?.message ||
              'Failed to save column settings'
          });
        }
      });
  }

  sortColumn(column: string) {
    if (this.order_by === column) {
      this.order_type = this.order_type === 1 ? 0 : 1;
    } else {
      this.order_by = column;
      this.order_type = 1;
    }
    this.currentPage = 1;
    this.loadTrackerList(1);
  }

  closeColumnSetting() {
    this.showColumnSettings = false;
  }

  resetFilters() {
    Object.keys(this.filterModel).forEach(key => {
      if (Array.isArray(this.filterModel[key])) {
        this.filterModel[key] = [];
      } else {
        this.filterModel[key] = null;
      }
    });
    this.acknowledgementStatus = null;
    this.slaFilter = null;
    this.correlationKey = null;
    this.correlationValue = null;
    this.closeFilter();
    this.loadTrackerList(1);
  }

  infoClick(event: any) {
    this.selectedWFID = event?.wfid;
    this.selectedParentWFID = event?.parent_wfid || null;
    this.selectedParentDocId = event?.parent_document || null;
    const docId = event?.id;
    if (!docId) return;
    this.selectedDocId = docId;
    this.showLogModal = true;
    this.resetLogState();
    this.isLogsLoading = true;
    this.adminService.getDocProcessingLog({ document_id: docId }).subscribe({
      next: (res: any) => {
        this.prepareLogs(res);
        this.isLogsLoading = false;
      },
      error: () => {
        this.resetLogState();
        this.isLogsLoading = false;
      }
    });
  }

  /** Open the uploaded document a derived workflow was fanned out from. */
  openParentWorkflow() {
    if (!this.selectedParentDocId) return;
    this.infoClick({ id: this.selectedParentDocId, wfid: this.selectedParentWFID });
  }
  refreshLogs() {
    if (this.selectedDocId == null || this.isLogsLoading) return;
    const previousAttempt = this.selectedAttempt;
    this.isLogsLoading = true;

    this.adminService.getDocProcessingLog({ document_id: this.selectedDocId }).subscribe({
      next: (res: any) => {
        this.prepareLogs(res);
        if (previousAttempt !== null && this.groupedLogs[previousAttempt] !== undefined) {
          this.selectedAttempt = previousAttempt;
          this.syncTabWindow();
        }
        this.isLogsLoading = false;
      },
      error: () => {
        this.isLogsLoading = false;
      }
    });
  }
  private resetLogState() {
    this.documentLogs = [];
    this.groupedLogs = {};
    this.attempts = [];
    this.selectedAttempt = null;
    this.tabStart = 0;
  }

  private prepareLogs(res: any) {
    const logs: any[] = res?.results || [];
    this.documentLogs = logs;
    this.groupedLogs = logs.reduce((acc: Record<number, any[]>, log: any) => {
      const key = Number(log?.attempt ?? 0);
      (acc[key] = acc[key] || []).push(log);
      return acc;
    }, {});
    const fromApi: AttemptInfo[] = res?.attempts?.length ? [...res.attempts] : [];
    this.attempts = (fromApi.length
      ? fromApi
      : Object.keys(this.groupedLogs).map(k => ({
        attempt: Number(k),
        log_count: this.groupedLogs[Number(k)].length
      }))
    ).sort((a, b) => a.attempt - b.attempt);
    // default to the current attempt, else the latest one we have
    const current = Number(res?.document?.current_attempt);
    this.selectedAttempt =
      current && this.groupedLogs[current] !== undefined
        ? current
        : this.attempts.length
          ? this.attempts[this.attempts.length - 1].attempt
          : null;

    this.syncTabWindow();
  }

  /* ---------- tabs ---------- */

  get visibleAttempts(): AttemptInfo[] {
    return this.attempts.slice(this.tabStart, this.tabStart + this.visibleTabCount);
  }

  get maxTabStart(): number {
    return Math.max(0, this.attempts.length - this.visibleTabCount);
  }

  get canGoPrev(): boolean {
    return this.tabStart > 0;
  }

  get canGoNext(): boolean {
    return this.tabStart < this.maxTabStart;
  }

  get showTabPager(): boolean {
    return this.attempts.length > this.visibleTabCount;
  }

  prevTabs() {
    this.tabStart = Math.max(0, this.tabStart - 1);
  }

  nextTabs() {
    this.tabStart = Math.min(this.maxTabStart, this.tabStart + 1);
  }
  selectAttempt(attempt: number) {
    this.selectedAttempt = attempt;
    this.isAttemptDropdownOpen = false;
  }

  /** keeps the selected tab inside the visible window */
  private syncTabWindow() {
    const idx = this.attempts.findIndex(a => a.attempt === this.selectedAttempt);
    if (idx === -1) { this.tabStart = 0; return; }
    if (idx < this.tabStart) this.tabStart = idx;
    else if (idx >= this.tabStart + this.visibleTabCount)
      this.tabStart = idx - this.visibleTabCount + 1;
    this.tabStart = Math.min(this.tabStart, this.maxTabStart);
  }

  /* ---------- data for the table ---------- */

  get activeLogs(): any[] {
    return this.selectedAttempt !== null
      ? this.groupedLogs[this.selectedAttempt] || []
      : [];
  }

  get activeAttemptInfo(): AttemptInfo | null {
    return this.attempts.find(a => a.attempt === this.selectedAttempt) || null;
  }

  attemptLogCount(a: AttemptInfo): number {
    return a.log_count ?? (this.groupedLogs[a.attempt]?.length || 0);
  }

  /* ---------- badges ---------- */

  statusBadgeClass(status?: string | null): string {
    switch ((status || '').toUpperCase()) {
      case 'SUCCESS':
      case 'COMPLETED':
        return 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-400/20';
      case 'ERROR':
      case 'FAILED':
        return 'bg-rose-50 text-rose-700 ring-rose-600/20 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-400/20';
      case 'WARNING':
        return 'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-400/20';
      case 'IN PROGRESS':
      case 'WAITING FOR ACK':
        return 'bg-blue-50 text-blue-700 ring-blue-600/20 dark:bg-blue-500/10 dark:text-blue-300 dark:ring-blue-400/20';
      default:
        return 'bg-gray-100 text-gray-600 ring-gray-500/20 dark:bg-gray-700/40 dark:text-gray-300 dark:ring-gray-500/20';
    }
  }

  triggerBadgeClass(trigger?: string | null): string {
    switch ((trigger || '').toUpperCase()) {
      case 'INITIAL':
        return 'bg-indigo-50 text-indigo-700 ring-indigo-600/20 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-400/20';
      case 'REPROCESS':
        return 'bg-violet-50 text-violet-700 ring-violet-600/20 dark:bg-violet-500/10 dark:text-violet-300 dark:ring-violet-400/20';
      default:
        return 'bg-gray-100 text-gray-600 ring-gray-500/20 dark:bg-gray-700/40 dark:text-gray-300 dark:ring-gray-500/20';
    }
  }

  closeModal() {
    this.showLogModal = false;
    this.selectedParentWFID = null;
    this.selectedParentDocId = null;
  }

  getTimelineColor(status: string | null | undefined): string {
    const s = status?.toUpperCase();
    if (s === 'WARNING') return '#f59e0b';
    if (s === 'IN PROGRESS') return '#6366f1';
    return this.getStatusColor(status ?? '');
  }

  openJsonModal(data: any, log?: any) {
    this.showJsonModal = true;
    this.selectedJsonData = '';
    this.processedView = 'structured';
    this.expandedPayloadPaths = new Set<string>();
    this.payloadCache = { text: '', search: '', nodes: null };
    this.copiedPayloadPath = null;
    this.selectedErrorLog = log ?? null;
    this.aiExplanation = null;
    this.aiErrorMessage = null;
    this.isAiLoading = false;
    this.aiCopied = false;
    this.isOutputFileLoading = true;
    if (typeof data === 'string' && data.startsWith('http')) {
      this.http.get(data, { responseType: 'text' }).subscribe({
        next: (res: string) => {
          this.selectedJsonData = this.formatData(res);
          this.isOutputFileLoading = false;
        },
        error: (err) => {
          this.selectedJsonData = 'Unable to load file.';
          this.isOutputFileLoading = false;
        }
      });
    } else if (typeof data === 'object') {
      this.selectedJsonData = this.formatData(data);
      this.isOutputFileLoading = false
    } else if (typeof data === 'string') {
      this.selectedJsonData = this.formatData(data);
      this.isOutputFileLoading = false;
    }
  }

  formatData = (input: any) => {
    try {
      if (typeof input === 'object') {
        return JSON.stringify(input, null, 2);
      }
      if (typeof input === 'string') {
        let trimmed = input.trim();
        if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
          return JSON.stringify(JSON.parse(trimmed), null, 2);
        }
        if (trimmed.includes('~') && !trimmed.includes('\n')) {
          trimmed = trimmed.replaceAll(/\r?\n|\r/g, '').trim();  // remove extra newlines and trim
          return trimmed.replaceAll('~', '~\n');
        }
        if (trimmed.includes("'") && !trimmed.includes('\n')) {
          trimmed = trimmed.replaceAll(/\r?\n|\r/g, '').trim();  // remove extra newlines and trim
          return trimmed.replaceAll('\'', "'\n");
        }
        return trimmed;
      }
      return input;
    } catch (e) {
      return input;
    }
  };

  /** Structured rows for the Processed Data modal, or null when the
   * payload is not a JSON object/array (then only the raw view applies).
   * Memoized: payloads can be large and getters run every change-detection
   * cycle, so recompute only when the text or the search changes. Rows also
   * honor the modal search box by filtering on key or value. */
  get structuredRows(): { key: string; value: unknown }[] | null {
    const text = typeof this.selectedJsonData === 'string' ? this.selectedJsonData : '';
    const search = (this.pd_SearchText || '').trim();
    const cached = this.structuredCache;
    if (text === cached.text && search === cached.search) {
      return cached.rows;
    }
    cached.text = text;
    cached.search = search;
    cached.rows = this.buildStructuredRows(text, search.toLowerCase());
    return cached.rows;
  }

  private buildStructuredRows(text: string, query: string): { key: string; value: unknown }[] | null {
    const trimmed = text.trim();
    if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
      return null;
    }
    let parsed: unknown;
    try {
      parsed = JSON.parse(trimmed);
    } catch {
      return null;
    }
    if (parsed === null || typeof parsed !== 'object') {
      return null;
    }
    const rows = Array.isArray(parsed)
      ? parsed.map((value, index) => ({ key: String(index), value: value as unknown }))
      : Object.entries(parsed).map(([key, value]) => ({ key, value: value as unknown }));
    if (!query) {
      return rows;
    }
    return rows.filter(row =>
      row.key.toLowerCase().includes(query) ||
      this.structuredValueText(row.value, row.key).toLowerCase().includes(query)
    );
  }

  /** Recursive payload tree for the Structured tab. Null when the payload
   * is not a JSON object/array (then only Raw applies). Memoized like
   * structuredRows. Search filters deep matches and auto-expands ancestors. */
  get payloadTree(): PayloadNode[] | null {
    const text = typeof this.selectedJsonData === 'string' ? this.selectedJsonData : '';
    const search = (this.pd_SearchText || '').trim();
    const cached = this.payloadCache;
    if (text === cached.text && search === cached.search) {
      return cached.nodes;
    }
    cached.text = text;
    cached.search = search;
    cached.nodes = this.buildPayloadTree(text, search.toLowerCase());
    return cached.nodes;
  }

  private buildPayloadTree(text: string, query: string): PayloadNode[] | null {
    const trimmed = text.trim();
    if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
      return null;
    }
    let parsed: unknown;
    try {
      parsed = JSON.parse(trimmed);
    } catch {
      return null;
    }
    if (parsed === null || typeof parsed !== 'object') {
      return null;
    }
    const roots = Array.isArray(parsed)
      ? parsed.map((value, index) => this.buildPayloadNode(String(index), value, String(index), 0))
      : Object.entries(parsed).map(([key, value]) => this.buildPayloadNode(key, value, key, 0));
    if (!query) {
      return roots;
    }
    return this.filterPayloadNodes(roots, query);
  }

  private buildPayloadNode(key: string, value: unknown, path: string, depth: number): PayloadNode {
    if (value === null) {
      return { key, path, depth, type: 'null', value };
    }
    if (Array.isArray(value)) {
      return {
        key, path, depth, type: 'array', count: value.length,
        children: value.map((item, index) =>
          this.buildPayloadNode(String(index), item, `${path}[${index}]`, depth + 1)),
      };
    }
    if (typeof value === 'object') {
      const entries = Object.entries(value as Record<string, unknown>);
      return {
        key, path, depth, type: 'object', count: entries.length,
        children: entries.map(([k, v]) =>
          this.buildPayloadNode(k, v, path ? `${path}.${k}` : k, depth + 1)),
      };
    }
    return {
      key, path, depth,
      type: typeof value === 'number' ? 'number' : typeof value === 'boolean' ? 'boolean' : 'string',
      value,
    };
  }

  private filterPayloadNodes(nodes: PayloadNode[], query: string): PayloadNode[] {
    const out: PayloadNode[] = [];
    for (const node of nodes) {
      const keyHit = node.key.toLowerCase().includes(query) ||
        node.path.toLowerCase().includes(query);
      if (node.children) {
        const kept = this.filterPayloadNodes(node.children, query);
        const selfHit = keyHit || this.payloadPrimitiveText(node).toLowerCase().includes(query);
        if (kept.length || selfHit) {
          out.push({ ...node, children: kept.length || selfHit ? (kept.length ? kept : node.children) : [] });
        }
      } else if (keyHit || this.payloadPrimitiveText(node).toLowerCase().includes(query)) {
        out.push(node);
      }
    }
    return out;
  }

  private payloadPrimitiveText(node: PayloadNode): string {
    if (node.type === 'null') return '';
    if (node.type === 'object' || node.type === 'array') return '';
    return this.structuredValueText(node.value, node.key);
  }

  isPayloadExpanded(node: PayloadNode): boolean {
    if ((this.pd_SearchText || '').trim()) return true;
    if (this.expandedPayloadPaths.has(node.path)) return true;
    return node.depth < this.PAYLOAD_INITIAL_EXPAND_DEPTH;
  }

  togglePayloadNode(node: PayloadNode): void {
    if (this.expandedPayloadPaths.has(node.path)) {
      this.expandedPayloadPaths.delete(node.path);
    } else {
      this.expandedPayloadPaths.add(node.path);
    }
  }

  expandAllPayload(): void {
    const walk = (nodes: PayloadNode[] | null) => {
      if (!nodes) return;
      for (const n of nodes) {
        if (n.children) {
          this.expandedPayloadPaths.add(n.path);
          walk(n.children);
        }
      }
    };
    walk(this.payloadTree);
  }

  collapseAllPayload(): void {
    this.expandedPayloadPaths = new Set<string>();
  }

  payloadValueText(node: PayloadNode): string {
    if (node.type === 'null') return '—';
    return this.structuredValueText(node.value, node.key);
  }

  copyPayloadText(text: string, path: string): void {
    const done = () => {
      this.copiedPayloadPath = path;
      if (this.payloadCopyTimer) clearTimeout(this.payloadCopyTimer);
      this.payloadCopyTimer = setTimeout(() => { this.copiedPayloadPath = null; }, 1500);
    };
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(done, () => done());
    } else {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch { /* clipboard unavailable */ }
      document.body.removeChild(ta);
      done();
    }
  }

  /** Human-readable label: source_connectivity_profile → Source Connectivity Profile. */
  prettyPayloadKey(key: string): string {
    if (/^\d+$/.test(key)) {
      return `#${key}`;
    }
    return key.replaceAll('_', ' ').replaceAll(/\b\w/g, c => c.toUpperCase());
  }

  structuredValueText(value: unknown, key = ''): string {
    if (value === null || value === undefined) {
      return '—';
    }
    if (/file_size/i.test(key)) {
      const friendly = this.formatPayloadFileSize(value);
      if (friendly !== null) {
        return friendly;
      }
    }
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }
    return String(value);
  }

  /** 6440 → "6.3 KB (6440 bytes)". Non-numeric values return null so the
   * raw text is shown instead. Reuses the existing formatFileSize helper. */
  private formatPayloadFileSize(value: unknown): string | null {
    const bytes = typeof value === 'number'
      ? value
      : /^-?\d+(\.\d+)?$/.test(String(value).trim())
        ? Number(String(value).trim())
        : Number.NaN;
    if (!Number.isFinite(bytes) || bytes < 0) {
      return null;
    }
    return `${this.formatFileSize(bytes)} (${bytes} bytes)`;
  }

  isUrlValue(value: unknown): boolean {
    return typeof value === 'string' && /^https?:\/\//i.test(value.trim());
  }

  isComplexValue(value: unknown): boolean {
    return value !== null && typeof value === 'object';
  }

  formatContent(data: string): string {
    let formatted = data;
    try {
      const json = JSON.parse(data);
      formatted = JSON.stringify(json, null, 2);
    } catch {
      formatted = data.replaceAll(/\r?\n|\r/g, '').trim();  // remove extra newlines and trim
    }
    // optional formatting (EDI readability)
    return formatted.replaceAll('\'', "'\n");
  }

  closeJsonModal() {
    this.showJsonModal = false;
    this.selectedJsonData = null;
    this.expandedPayloadPaths = new Set<string>();
    this.payloadCache = { text: '', search: '', nodes: null };
    this.copiedPayloadPath = null;
    this.selectedErrorLog = null;
    this.aiExplanation = null;
    this.aiErrorMessage = null;
    this.isAiLoading = false;
    this.aiCopied = false;
    this.pd_SearchText = '';
    this.pd_MatchCount = 0;
  }

  closeAiExplanation() {
    this.aiExplanation = null;
    this.aiErrorMessage = null;
    this.isAiLoading = false;
    this.aiCopied = false;
  }

  copyAiExplanation() {
    if (!this.aiExplanation) return;
    const done = () => {
      this.aiCopied = true;
      if (this.aiCopyTimer) clearTimeout(this.aiCopyTimer);
      this.aiCopyTimer = setTimeout(() => { this.aiCopied = false; }, 1500);
    };
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(this.aiExplanation).then(done, () => done());
    } else {
      const ta = document.createElement('textarea');
      ta.value = this.aiExplanation;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch { /* clipboard unavailable */ }
      document.body.removeChild(ta);
      done();
    }
  }

  get showAiExplainButton(): boolean {
    return (this.selectedErrorLog?.status || '').toUpperCase() === 'ERROR';
  }

  explainErrorWithAi() {
    if (!this.showAiExplainButton || this.isAiLoading) return;
    const documentId = this.selectedDocId;
    const logId = this.selectedErrorLog?.id;
    if (!documentId || !logId) {
      this.aiErrorMessage = 'Could not identify this log. Please reopen it and try again.';
      return;
    }
    this.isAiLoading = true;
    this.aiErrorMessage = null;
    this.aiExplanation = null;
    this.aiCopied = false;
    this.adminService.explainDocError({ document_id: documentId, log_id: logId }).subscribe({
      next: (res: any) => {
        this.isAiLoading = false;
        this.aiExplanation = res?.data?.explanation || res?.explanation || null;
        if (!this.aiExplanation) {
          this.aiErrorMessage = res?.message || 'The AI could not explain this error. Please try again.';
        }
      },
      error: (err) => {
        this.isAiLoading = false;
        this.aiErrorMessage = err?.error?.message || 'The AI is unavailable right now. Please try again.';
      }
    });
  }

  handleFileClick(row: any, key: string, url: any) {
    this.rowData = row;
    if (!url) return;
    if (key === 'document_source_url') {
      this.onClickViewInputFile(row?.document_source_url, 'INPUT');
    } else if (key === 'out_doc_source_url') {
      this.selectedOutputFileFormatName = row?.file_name_format;
      this.onClickViewOutputFile(row?.out_doc_source_url, 'OUTPUT');
    }
  }

  handleAcknowlegementClick(key: string, value: any, row: any) {
    if (key === 'ack_source_url' && value) {
      this.onClickViewAcknowledgeFile(row?.ack_source_url, 'ACK');
    }
  }

  getFileExtensionFromFileName(fileName: string): string {
    if (!fileName) return 'txt';
    return fileName.split('.').pop()?.toLowerCase() || 'txt';
  }

  onClickViewInputFile(doc: any, fileType: string) {
    this.isFileLoading = true;
    this.inputFileContent = '';
    this.inputFileType = 'txt';
    this.isInputFileModalVisible = true;

    this.masterDataService.getFileData(doc?.file_id, fileType).subscribe({
      next: (res: any) => {
        const data: string = res?.content || '';
        let formattedData = data;

        try {
          // 1. JSON
          formattedData = JSON.stringify(JSON.parse(data), null, 2);
          this.inputFileType = 'json';
        } catch {
          // 2. XML / XSD (returns null if it isn't well-formed XML)
          const xml = data.trim().startsWith('<') ? this.formatXml(data) : null;

          if (xml) {
            formattedData = xml;
            this.inputFileType = 'xml';
          } else {
            // 3. EDI-style files with a segment separator
            let sep = doc?.segment_sep;
            if (!sep) {
              if (data.includes('~')) sep = '~';
              else if (data.includes("'")) sep = "'";
              else sep = '';
            }
            if (sep) {
              const escapedSep = sep.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
              const cleaned = data.replaceAll(/\r?\n|\r/g, '').trim();
              formattedData = cleaned.replaceAll(new RegExp(escapedSep, 'g'), sep + '\n');
            }
            this.inputFileType =
              doc?.type || this.getFileExtensionFromFileName(res?.file_name);
          }
        }

        this.inputFileContent = formattedData;
        this.isFileLoading = false;
      },
      error: () => {
        this.isFileLoading = false;
      }
    });
  }

  onClickViewOutputFile(doc: any, fileType: string) {
    this.isOutputFileLoading = true;
    this.outputFileContent = '';
    this.outputFileType = 'txt';
    this.isOutputFileModalVisible = true;
    this.masterDataService.getFileData(doc?.file_id, fileType).subscribe({
      next: (res: any) => {
        let data = res?.content || '';
        let sep = doc?.segment_sep;
        if (!sep) {
          if (data.includes('~')) sep = '~';
          else if (data.includes("'")) sep = "'";
          else sep = '';
        }
        let formattedData = data;
        try {
          const json = JSON.parse(data);
          formattedData = JSON.stringify(json, null, 2);
          this.outputFileType = 'json';
        } catch {
          if (sep) {
            const escapedSep =
              sep.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
            data.replaceAll(/\r?\n|\r/g, '').trim();  // remove extra newlines and trim
            formattedData = data.replaceAll(new RegExp(escapedSep, 'g'), sep + '\n');
          }
          this.outputFileType =
            this.getFileExtensionFromFileName(res?.file_name) ||
            doc?.file_type?.toLowerCase() ||
            'txt';
        }
        this.outputFileContent = formattedData;
        this.isOutputFileLoading = false;
      },
      error: () => {
        this.isOutputFileLoading = false;
      }
    });
  }

  onClickViewAcknowledgeFile(doc: any, fileType: string) {
    this.isAcknowledegeLoading = true;
    this.acknowledegeFileConent = '';
    this.acknowledgeFileType = 'txt';
    this.isAcknowledegeModalVisible = true;
    this.masterDataService.getFileData(doc?.file_id, fileType).subscribe({
      next: (res: any) => {
        const raw = (res?.content ?? '').toString();
        const { content, type } = this.formatFileContent(raw, doc, res);
        this.acknowledegeFileConent = content;
        this.acknowledgeFileType = type;
        this.isAcknowledegeLoading = false;
      },
      error: () => {
        this.acknowledegeFileConent = 'Unable to load file.';
        this.isAcknowledegeLoading = false;
      }
    });
  }

  private formatFileContent(raw: string, doc: any, res: any): { content: string; type: string } {
    const trimmed = raw.trim();
    if (!trimmed) return { content: '', type: 'txt' };
    // JSON
    if (/^[{[]/.test(trimmed)) {
      try {
        return { content: JSON.stringify(JSON.parse(trimmed), null, 2), type: 'json' };
      } catch { }
    }
    // XML
    if (trimmed.startsWith('<')) {
      const xml = this.formatXml(trimmed);
      if (xml) return { content: xml, type: 'xml' };
    }
    // EDI / flat file
    let sep = doc?.segment_sep;
    if (!sep) {
      if (trimmed.includes('~')) sep = '~';
      else if (trimmed.includes("'")) sep = "'";
    }
    if (sep) {
      const escaped = sep.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const flat = trimmed.replaceAll(/\r?\n|\r/g, '');
      return {
        content: flat.replaceAll(new RegExp(escaped, 'g'), sep + '\n'),
        type: this.getFileExtensionFromFileName(res?.file_name) || doc?.type?.toLowerCase() || 'txt'
      };
    }
    return {
      content: trimmed,
      type: this.getFileExtensionFromFileName(res?.file_name) || doc?.type?.toLowerCase() || 'txt'
    };
  }

  /** Linear-time equivalent of /^<([\w:.-]+)[^>]*>.*<\/\1>$/.
   * The open-tag name must be a prefix of the leading `[\w:.-]+` run (everything
   * up to the first `>` is `[^>]*` by definition) and the node must end with
   * `</name>`. Avoids backtracking between the overlapping `[\w:.-]+` /
   * `[^>]*` repetitions and the `.*` + backreference scan (typescript:S5852). */
  private _isSingleLineElement(node: string): boolean {
    const openRun = /^<([\w:.-]+)/.exec(node)?.[1];
    if (!openRun || !node.endsWith('>')) return false;
    const closeIdx = node.lastIndexOf('</');
    if (closeIdx < 0) return false;
    const closeName = node.slice(closeIdx + 2, -1);
    return closeName.length > 0 && openRun.startsWith(closeName);
  }

  private formatXml(xml: string, indent = '  '): string | null {
    try {
      const doc = new DOMParser().parseFromString(xml, 'application/xml');
      if (doc.getElementsByTagName('parsererror').length) return null;
    } catch {
      return null;
    }
    const src = xml.replaceAll(/\r?\n|\r/g, '').replaceAll(/>\s+</g, '><').trim();
    const nodes = src.replaceAll('><', '>\n<').split('\n');
    let pad = 0;
    return nodes.map(node => {
      if (/^<[?!]/.test(node)) return indent.repeat(pad) + node;
      if (/^<\//.test(node)) {
        pad = Math.max(pad - 1, 0);
        return indent.repeat(pad) + node;
      }
      if (/\/>$/.test(node)) return indent.repeat(pad) + node;
      if (this._isSingleLineElement(node)) return indent.repeat(pad) + node;
      const line = indent.repeat(pad) + node;
      pad++;
      return line;
    }).join('\n');
  }


  onFilterClick() {
    this.toggleFilter();
    if (this.isFilterOpen) {
      // Drawer renders immediately: statics assign synchronously,
      // dynamic values fill in per-column without blocking.
      this.assignStaticFilterOptions();
      this.ensureFilterOptions();
    }
  }

  toggleFilter() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  closeFilter() {
    this.isFilterOpen = false;
  }

  initializeFilterModel() {
    this.filterModel = {};
    this.filterable_columns.forEach((col: any) => {
      if (col.filter_type === 'calendar') {
        this.filterModel[col.key + '_start'] = null;
        this.filterModel[col.key + '_end'] = null;
      } else if (col.filter_type === 'multiselect') {
        this.filterModel[col.key] = [];
      } else {
        this.filterModel[col.key] = null;
      }
    });
    this.filterModel = this.adminService.initializeFilterModel(this.column_list);
  }

  loadDropdownOptions() {
    this.filterable_columns.forEach((col: any) => {
      if (
        col.filter_type === 'dropdown' ||
        col.filter_type === 'multiselect'
      ) {
        if (col.url_id) {
          this.getFilterUrlList(col.url_id);
        }
      }
    });
  }

  /** url_ids served by hardcoded backend branches — assign locally, no HTTP. Mirrors ModuleDropdownApi. */
  private static readonly STATIC_FILTER_OPTIONS: Record<number, { id: any; value: string }[]> = {
    2: [{ id: 1, value: 'Yes' }, { id: 0, value: 'No' }],
    106: [{ id: 'Accepted', value: 'Accepted' }, { id: 'Rejected', value: 'Rejected' }],
    107: [{ id: 'Within SLA', value: 'Within SLA' }, { id: 'Exceeded SLA', value: 'Exceeded SLA' }],
  };

  /** url_ids with an outstanding options request — drives per-dropdown spinners. */
  private readonly filterLoadingIds = new Set<number>();

  isColumnLoading(col: any): boolean {
    return col?.url_id != null && this.filterLoadingIds.has(col.url_id);
  }

  /** Step 1: hardcoded values need no HTTP and don't depend on the url list. */
  private assignStaticFilterOptions() {
    Object.entries(DocumentTrackerComponent.STATIC_FILTER_OPTIONS).forEach(([id, options]) => {
      this.assignDropdownOptions(Number(id), options);
    });
  }

  /** Non-blocking fan-out: statics are already assigned; each dynamic column
   * resolves independently so a slow/failed column can't block the drawer. */
  private ensureFilterOptions() {
    if (this.dropdown_list?.length) {
      this.loadDynamicFilterDropdowns();
      return;
    }
    const moduleId = Settings.Module.DOCUMENT_TRACKER;
    const cached = this.getCachedDropdown(`module_${moduleId}`);
    if (cached) {
      this.dropdown_list = cached;
      this.loadDynamicFilterDropdowns();
      return;
    }
    // The url list itself is a tiny static config; the drawer is already open.
    this.adminService.getUrlList(moduleId).subscribe({
      next: (res: any) => {
        this.dropdown_list = res || [];
        this.setCachedDropdown(`module_${moduleId}`, this.dropdown_list);
        this.loadDynamicFilterDropdowns();
      },
      error: () => { /* drawer stays usable with inputs + statics */ }
    });
  }
  private loadDynamicFilterDropdowns() {
    (this.dropdown_list || [])
      .filter((item: any) => item?.id != null && !DocumentTrackerComponent.STATIC_FILTER_OPTIONS[item.id])
      .forEach((item: any) => {
        const cached = this.getCachedDropdown(`column_${item.id}`);
        if (cached) {
          this.assignDropdownOptions(item.id, cached);
          return;
        }
        if (this.filterLoadingIds.has(item.id)) return;
        this.filterLoadingIds.add(item.id);
        this.adminService.getFilterUrlList(item.id).pipe(
          catchError(() => of([] as any[]))
        ).subscribe({
          next: (res: any[]) => {
            this.filterLoadingIds.delete(item.id);
            const list = res ?? [];
            this.setCachedDropdown(`column_${item.id}`, list);
            this.assignDropdownOptions(item.id, list);
          }
        });
      });
  }
  private assignDropdownOptions(id: number, res: any[]) {
    const column = this.filterable_columns.find(
      (col: any) =>
        col.url_id === id &&
        (col.filter_type === 'dropdown' ||
          col.filter_type === 'multiselect')
    );
    if (column) {
      column.filter_options = [...res];
    }
  }

  private getCachedDropdown(key: string): any[] | null {
    const cacheKey = `map_lib_dropdown_${this.customerId ?? 'all'}_${key}`;
    const raw = localStorage.getItem(cacheKey);
    if (!raw) return null;
    try {
      const { ts, data } = JSON.parse(raw);
      if (Date.now() - ts > this.DROPDOWN_CACHE_TTL_MS) {
        localStorage.removeItem(cacheKey);
        return null;
      }
      return Array.isArray(data) ? data : null;
    } catch {
      localStorage.removeItem(cacheKey);
      return null;
    }
  }

  private setCachedDropdown(key: string, data: any[]) {
    const cacheKey = `map_lib_dropdown_${this.customerId ?? 'all'}_${key}`;
    localStorage.setItem(
      cacheKey,
      JSON.stringify({ ts: Date.now(), data })
    );
  }

  getFilterUrlList(id: number) {
    this.adminService.getFilterUrlList(id).subscribe({
      next: (res: any[]) => {
        const column = this.filterable_columns.find(
          (col: any) =>
            col.url_id === id &&
            (col.filter_type === 'dropdown' ||
              col.filter_type === 'multiselect')
        );
        if (column) {
          column.filter_options = [...res].sort((a, b) =>
            (a.value || '').localeCompare(b.value || '', undefined, {
              sensitivity: 'base'
            })
          );
        }
      },
      error: err => {
      }
    });

  }

  onInputChange(event: any) {
    this.serchInput = event.target.value;
    this.searchValue = event.target.value;
    this.searchSubject.next(this.serchInput);
  }

  // Clear Search
  onClearFilter(e: any) {
    this.serchInput = '';
    this.searchValue = '';
    this.searchSubject.next('');
    this.loadTrackerList(1);
  }

  // Global Search — server-side
  onFilterSearch() {
    this.searchSubject.next(this.serchInput);
  }

  /** Open the search bar and focus the input */
  expand(): void {
    this.isExpanded = true;
    setTimeout(() => {
      this.searchInputRef?.nativeElement.focus();
    }, 50);
  }

  /** Close the search bar and clear the input */
  collapse(): void {
    this.isExpanded = false;
    this.serchInput = '';
    this.searchValue = '';
    this.closed.emit();
    this.searchSubject.next('');
  }

  onSearch(): void {
    const query = this.searchValue.trim();
    if (query) {
      this.searched.emit(query);
    }
  }

  onDocumentClick(event: MouseEvent): void {
    if (
      this.isExpanded &&
      !this.host.nativeElement.contains(event.target as Node)
    ) {
      this.collapse();
    }
  }

  downloadInputFile(rowData: any) {
    if (!this.inputFileContent) return;
    const ext = this.inputFileType || 'txt';

    let fileName: string;
    const apiName = rowData?.document_source_url?.file_name;
    if (apiName) {
      const baseName = String(apiName).replace(/\.[^.]+$/, '');   // strip existing extension
      fileName = `${baseName}_${this.getFormattedDateTime()}.${ext}`;
    } else {
      fileName = `input_file_${this.getFormattedDateTime()}.${ext}`;
    }

    const mimeTypes: any = {
      json: 'application/json',
      txt: 'text/plain',
      edi: 'application/edi',
      xml: 'application/xml',
      csv: 'text/csv'
    };

    const blob = new Blob([this.inputFileContent], {
      type: mimeTypes[ext] || 'text/plain',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
  }

  downloadProcessedFile() {
    if (!this.selectedJsonData) return;
    let content = this.selectedJsonData;
    let extension = 'txt';
    try {
      const trimmed = content.trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        JSON.parse(trimmed);
        extension = 'json';
      }
      else if (trimmed.includes("'") && trimmed.includes('+')) {
        extension = 'edi';
      }
      else {
        extension = 'txt';
      }
    } catch (e) {
      extension = 'txt';
    }
    const fileName = `processed_data_${this.getFormattedDateTime()}.${extension}`;
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  downloadOutputFile() {
    if (!this.outputFileContent) return;
    const ext = this.outputFileType || 'txt';
    const baseName = this.selectedOutputFileFormatName || 'output_file';
    const fileName = `${baseName}_${this.getFormattedDateTime()}.${ext}`;
    const mimeTypes: any = {
      json: 'application/json',
      txt: 'text/plain',
      edi: 'application/edi',
      xml: 'application/xml',
      csv: 'text/csv'
    };
    const blob = new Blob([this.outputFileContent], {
      type: mimeTypes[ext] || 'text/plain',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
  }

  downloadAcknowledgeFile() {
    if (!this.acknowledegeFileConent) return;
    const ext = this.acknowledgeFileType || 'txt';
    const fileName = `acknowledgement_file_${this.getFormattedDateTime()}.${ext}`;
    const mimeTypes: any = {
      json: 'application/json',
      txt: 'text/plain',
      edi: 'application/edi-x12',
      xml: 'application/xml',
      csv: 'text/csv'
    };
    const blob = new Blob([this.acknowledegeFileConent], {
      type: mimeTypes[ext] || 'text/plain',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getFormattedDateTime() {
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_` +
      `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  }

  onClearInputSearch() {
    this.searchText = '';
    this.matchCount = 0;
  }

  updateMatchCount() {
    if (!this.searchText) {
      this.matchCount = 0;
      return;
    }
    const escaped = this.searchText.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    //convert JSON → string
    const jsonStr = typeof this.inputFileContent === 'string'
      ? this.inputFileContent
      : JSON.stringify(this.inputFileContent, null, 2);
    const matches = jsonStr.match(regex);
    this.matchCount = matches ? matches.length : 0;
  }

  scrollToFirstMatch() {
    setTimeout(() => {
      const el: HTMLElement = this.inContainer.nativeElement;
      const firstMatch = el.querySelector('span.bg-yellow-300') as HTMLElement;
      if (firstMatch) {
        firstMatch.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }

  onClearOutputSearch() {
    this.outSearchText = '';
    this.outMatchCount = 0;
  }

  updateOutputMatchCount() {
    if (!this.outSearchText) {
      this.outMatchCount = 0;
      return;
    }
    const escaped = this.outSearchText.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    const jsonStr = typeof this.outputFileContent === 'string'
      ? this.outputFileContent
      : JSON.stringify(this.outputFileContent, null, 2);
    const matches = jsonStr.match(regex);
    this.outMatchCount = matches ? matches.length : 0;
  }

  scrollToOutputMatch() {
    setTimeout(() => {
      const el: HTMLElement = this.outContainer.nativeElement;
      const firstMatch = el.querySelector('span.bg-yellow-300') as HTMLElement;
      if (firstMatch) {
        firstMatch.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }

  // Acknowledgement dialog search functionality
  onClearAckSearch() {
    this.ackSearchText = '';
    this.ackMatchCount = 0;
  }

  updateAckMatchCount() {
    if (!this.ackSearchText) {
      this.ackMatchCount = 0;
      return;
    }
    const escaped = this.ackSearchText.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    // convert JSON → string
    const jsonStr = typeof this.acknowledegeFileConent === 'string'
      ? this.acknowledegeFileConent
      : JSON.stringify(this.acknowledegeFileConent, null, 2);
    const matches = jsonStr.match(regex);
    this.ackMatchCount = matches ? matches.length : 0;
  }

  scrollToAckMatch() {
    setTimeout(() => {
      const el: HTMLElement = this.ackContainer.nativeElement;
      const firstMatch = el.querySelector('span.bg-yellow-300') as HTMLElement;
      if (firstMatch) {
        firstMatch.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }

  onClearProcessDataSearch() {
    this.pd_SearchText = '';
    this.pd_MatchCount = 0;
  }

  updateProcessDataMatchCount() {
    if (!this.pd_SearchText) {
      this.pd_MatchCount = 0;
      return;
    }
    const escaped = this.pd_SearchText.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    const jsonStr = typeof this.selectedJsonData === 'string'
      ? this.selectedJsonData
      : JSON.stringify(this.selectedJsonData, null, 2);
    const matches = jsonStr.match(regex);
    this.pd_MatchCount = matches ? matches.length : 0;
  }

  scrollToProcessDataMatch() {
    setTimeout(() => {
      const el: HTMLElement = this.pdContainer.nativeElement;
      const firstMatch = el.querySelector('span.bg-yellow-300') as HTMLElement;
      if (firstMatch) {
        firstMatch.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }

  // Open Modal
  openUploadModal() {
    this.showUploadModal = true;
    this.selectedUploadFiles = [];
    this.uploadFileStatuses = [];
    this.uploadFileErrors = [];
    this.uploadValidationError = '';
    this.uploadSummary = null;
    this.uploadCompletedCount = 0;
    this.previewIndex = null;
    this.previewText = '';
    this.previewTruncated = false;
    this.previewError = null;
    this.previewLoading = false;
    this.uploadDragOver = false;
  }

  // Close Modal
  closeUploadModal() {
    if (this.isUploading) return;
    this.showUploadModal = false;
    this.selectedUploadFiles = [];
    this.uploadFileStatuses = [];
    this.uploadFileErrors = [];
    this.uploadValidationError = '';
    this.uploadSummary = null;
    this.uploadCompletedCount = 0;
    this.previewIndex = null;
    this.previewText = '';
    this.previewTruncated = false;
    this.previewError = null;
    this.uploadDragOver = false;
  }

  getFileExtension(file: File): string {
    const name = file?.name || '';
    const dot = name.lastIndexOf('.');
    return dot >= 0 ? name.slice(dot).toLowerCase() : '';
  }

  getUploadExtBadgeClass(ext: string): string {
    switch ((ext || '').toLowerCase()) {
      case '.json':
        return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300';
      case '.xml':
        return 'bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300';
      case '.csv':
        return 'bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300';
      case '.edi':
        return 'bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300';
      case '.pff':
        return 'bg-rose-100 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300';
      default:
        return 'bg-gray-100 text-gray-600 dark:bg-gray-700/40 dark:text-gray-300';
    }
  }

  get uploadOverallProgress(): number {
    if (!this.selectedUploadFiles.length) return 0;
    return Math.round((this.uploadCompletedCount / this.selectedUploadFiles.length) * 100);
  }

  get uploadSucceededCount(): number {
    return this.uploadFileStatuses.filter(s => s === 'done').length;
  }

  get uploadFailedCount(): number {
    return this.uploadFileStatuses.filter(s => s === 'failed').length;
  }

  get hasFailedUploads(): boolean {
    return this.uploadFailedCount > 0;
  }

  private syncUploadStatusArrays() {
    while (this.uploadFileStatuses.length < this.selectedUploadFiles.length) {
      this.uploadFileStatuses.push('pending');
      this.uploadFileErrors.push(null);
    }
    this.uploadFileStatuses.length = this.selectedUploadFiles.length;
    this.uploadFileErrors.length = this.selectedUploadFiles.length;
  }

  addUploadFiles(files: File[]) {
    this.uploadValidationError = '';
    if (!files.length) return;
    const room = this.maxFiles - this.selectedUploadFiles.length;
    if (room <= 0) {
      this.uploadValidationError = `You can upload a maximum of ${this.maxFiles} files.`;
      return;
    }
    const known = new Set(this.selectedUploadFiles.map(f => `${f.name}:${f.size}:${f.lastModified}`));
    const accepted: File[] = [];
    for (const file of files.slice(0, room)) {
      const key = `${file.name}:${file.size}:${file.lastModified}`;
      if (known.has(key)) continue;
      const ext = this.getFileExtension(file);
      if (!this.uploadAcceptExts.includes(ext)) {
        this.uploadValidationError = `"${file.name}" is not supported. Allowed: ${this.uploadAcceptExts.join(', ')}`;
        continue;
      }
      if (file.size > this.uploadMaxBytes) {
        this.uploadValidationError = `"${file.name}" exceeds 2MB and was skipped.`;
        continue;
      }
      known.add(key);
      accepted.push(file);
    }
    if (files.length > room) {
      this.uploadValidationError = `You can upload a maximum of ${this.maxFiles} files.`;
    }
    if (!accepted.length) return;
    this.selectedUploadFiles = [...this.selectedUploadFiles, ...accepted];
    this.syncUploadStatusArrays();
    this.uploadSummary = null;
  }

  onUploadDragOver(event: DragEvent) {
    event.preventDefault();
    if (!this.isUploading) this.uploadDragOver = true;
  }

  onUploadDragLeave(event: DragEvent) {
    event.preventDefault();
    this.uploadDragOver = false;
  }

  onUploadDrop(event: DragEvent) {
    event.preventDefault();
    this.uploadDragOver = false;
    if (this.isUploading) return;
    const files = Array.from(event.dataTransfer?.files || []) as File[];
    this.addUploadFiles(files);
  }

  selectUploadPreview(index: number) {
    if (index < 0 || index >= this.selectedUploadFiles.length) return;
    this.previewIndex = index;
    this.previewText = '';
    this.previewTruncated = false;
    this.previewError = null;
    this.previewLoading = true;
    const file = this.selectedUploadFiles[index];
    file.text().then(
      text => {
        if (this.previewIndex !== index) return;
        const cap = 500 * 1024;
        this.previewTruncated = text.length > cap;
        this.previewText = this.previewTruncated ? text.slice(0, cap) : text;
        this.previewLoading = false;
      },
      () => {
        if (this.previewIndex !== index) return;
        this.previewError = 'Preview unavailable for this file.';
        this.previewLoading = false;
      }
    );
  }

  closeUploadPreview() {
    this.previewIndex = null;
    this.previewText = '';
    this.previewTruncated = false;
    this.previewError = null;
    this.previewLoading = false;
  }

  // File Select
  onFileSelected(event: any) {
    const files = Array.from(event.target.files || []) as File[];
    this.addUploadFiles(files);
    event.target.value = '';
  }

  removeSelectedFile(index: number) {
    if (this.isUploading) return;
    this.selectedUploadFiles.splice(index, 1);
    this.uploadFileStatuses.splice(index, 1);
    this.uploadFileErrors.splice(index, 1);
    this.uploadValidationError = '';
    this.uploadSummary = null;
    if (this.previewIndex === index) {
      this.closeUploadPreview();
    } else if (this.previewIndex !== null && this.previewIndex > index) {
      this.previewIndex -= 1;
    }
    if (!this.selectedUploadFiles.length) {
      this.closeUploadPreview();
    }
  }

  // Upload
  onUploadClick() {
    if (!this.selectedUploadFiles.length || this.isUploading) return;
    this.runUpload(this.selectedUploadFiles.map((_, i) => i));
  }

  retryFailedUploads() {
    if (this.isUploading) return;
    const failedIndexes = this.selectedUploadFiles
      .map((_, i) => i)
      .filter(i => this.uploadFileStatuses[i] === 'failed');
    if (!failedIndexes.length) return;
    this.runUpload(failedIndexes);
  }

  private runUpload(indexes: number[]) {
    if (!indexes.length || this.isUploading) return;
    this.syncUploadStatusArrays();
    this.isUploading = true;
    this.loading = true;
    this.uploadSummary = null;
    this.uploadCompletedCount = this.uploadFileStatuses.filter(s => s === 'done').length;
    const baseDone = this.uploadFileStatuses.filter(s => s === 'done').length;
    from(indexes).pipe(
      concatMap(index => {
        this.uploadFileStatuses[index] = 'uploading';
        this.uploadFileErrors[index] = null;
        const formData = new FormData();
        formData.append('file', this.selectedUploadFiles[index]);
        return this.adminService.uploadFile(formData).pipe(
          map(() => ({ index, success: true as boolean, error: null as any })),
          catchError(error => of({ index, success: false as boolean, error }))
        );
      }),
      toArray(),
      finalize(() => {
        this.loading = false;
        this.isUploading = false;
      })
    ).subscribe(results => {
      for (const result of results) {
        this.uploadFileStatuses[result.index] = result.success ? 'done' : 'failed';
        this.uploadFileErrors[result.index] = result.success
          ? null
          : (result.error?.error?.message || result.error?.message || 'Upload failed');
      }
      this.uploadCompletedCount = this.uploadFileStatuses.filter(s => s === 'done' || s === 'failed').length;
      const succeeded = this.uploadSucceededCount - baseDone;
      const failed = this.uploadFailedCount;
      if (succeeded > 0) this.loadTrackerList(1);
      const totalDone = this.uploadSucceededCount;
      const totalFailed = this.uploadFailedCount;
      if (!totalFailed) {
        this.uploadSummary = `${totalDone} file${totalDone === 1 ? '' : 's'} uploaded successfully`;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: this.uploadSummary });
      } else {
        this.uploadSummary = `${totalDone} uploaded, ${totalFailed} failed. Failed files stay selected so you can retry.`;
        this.messageService.add({
          severity: totalDone ? 'warn' : 'error',
          summary: totalDone ? 'Partially uploaded' : 'Upload failed',
          detail: this.uploadSummary
        });
      }
    });
  }

  getStatusColor(status: string): string {
    return this.statusColorService.getColor(status);
  }

  isStatusHighlight(status: string): boolean {
    return this.statusColorService.isHighlight(status);
  }

  toggleSelectAll(event: any) {
    const checked = event.checked;
    this.currentItems?.forEach((row: any) => (row.selected = checked));
  }

  onRowSelect(row: any) {
    this.selectAll = !!this.currentItems?.length &&
      this.currentItems.every((r: any) => r.selected);
  }

  getRowEvents(row: any): number[] {
    return this.statusColorService.getEvents(row?.status);
  }

  hasEvent(row: any, event: number): boolean {
    return this.getRowEvents(row).includes(event);
  }

  canSendMail(row: any): boolean {
    return Settings.StatusEvent.PRIMARY.some((e) => this.hasEvent(row, e));
  }

  /** Actions that live inside the ⋮ menu, in the order declared in SECONDARY. */
  getSecondaryActions(row: any): number[] {
    const events = this.getRowEvents(row);
    return Settings.StatusEvent.SECONDARY.filter((e) => events.includes(e));
  }

  /** Hide the ⋮ button entirely when there are no secondary actions. */
  hasSecondaryActions(row: any): boolean {
    return this.getSecondaryActions(row).length > 0;
  }

  /** Get comma-separated list of secondary action names for tooltip. */
  getSecondaryActionsTooltip(row: any): string {
    const actions = this.getSecondaryActions(row);
    if (!actions.length) return 'No actions available';
    return actions.map(e => this.getActionLabel(e)).join(', ');
  }

  getActionLabel(event: number): string {
    return Settings.StatusEvent.labelOf(event);
  }

  getActionIcon(event: number): string {
    return Settings.StatusEvent.iconOf(event);
  }

  /** Builds the menu for this row's configured actions, then opens the popup. */
  openActionMenu(row: any, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeMenuRow === row) {
      this.activeMenuRow = null;
      this.rowActionMenu?.hide();
      return;
    }
    this.activeMenuRow = row;
    this.actionMenuItems = this.getSecondaryActions(row).map(
      (action: number): MenuItem => ({
        label: this.getActionLabel(action),
        icon: this.getActionIcon(action),
        command: () => this.onActionSelect(action, row)
      })
    );
    this.rowActionMenu?.show(event);
  }

  onActionSelect(event: number, row: any) {
    this.remarkEvent = event;
    this.remarkRow = row;
    this.pendingDocumentIds = [];   // ← add
    this.remarkText = '';
    this.showRemarkModal = true;
  }

  closeRemarkModal(): void {
    this.showRemarkModal = false;
    this.remarkRow = null;
    this.pendingDocumentIds = [];   // ← add
    this.remarkEvent = null;
    this.remarkText = '';
  }
  /** Called by the modal's Proceed button. Routes to row or bulk. */
  confirmRemarkAction(): void {
    if (this.isProceedDisabled) return;

    if (this.pendingDocumentIds.length) {
      this.confirmBulkRemarkAction();
    } else {
      this.confirmRowRemarkAction();
    }
  }

  confirmRowRemarkAction(): void {
    this.isProceeding = true;
    if (this.isProceedDisabled) return;
    if (!this.remarkRow?.id || this.remarkEvent == null) return;
    const body = {
      document_ids: [this.remarkRow.id],
      event: this.remarkEvent,
      remark: this.remarkText.trim() || null,   // null when empty (optional actions)
    };
    // this.loaderService.show();
    this.adminService.sendActionRemarkDocTracker(body).subscribe({
      next: (res: any) => {
        // this.loaderService.hide();
        this.isProceeding = false;
        this.closeRemarkModal();
        this.loadTrackerList(1);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.message || 'Action completed successfully'
        });
      },
      error: (err: any) => {
        this.isProceeding = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to complete action'
        });
      }
    });
  }

  get remarkActionLabel(): string {
    if (this.remarkEvent == null) return 'Action';
    return Settings.StatusEvent.labelOf(this.remarkEvent);
  }

  get selectedCount(): number {
    return this.tableData.filter((row: any) => row.selected).length;
  }

  clearSelection() {
    this.tableData.forEach((row: any) => (row.selected = false));
    this.selectAll = false;
  }

  getSelectedRows(): any[] {
    return this.tableData.filter((row: any) => row.selected);
  }

  getBulkAvailableEvents(): number[] {
    const selectedRows = this.getSelectedRows();
    if (!selectedRows.length) return [];
    const allEvents = new Set<number>();
    selectedRows.forEach((row: any) => {
      const events = this.getRowEvents(row);
      events.forEach((e: number) => allEvents.add(e));
    });
    return Array.from(allEvents);
  }

  canBulkSendMail(): boolean {
    return Settings.StatusEvent.PRIMARY.some((e) =>
      this.getBulkAvailableEvents().includes(e)
    );
  }

  getBulkSecondaryActions(): number[] {
    const events = this.getBulkAvailableEvents();
    return Settings.StatusEvent.SECONDARY.filter((e) => events.includes(e));
  }

  hasBulkSecondaryActions(): boolean {
    return this.getBulkSecondaryActions().length > 0;
  }

  openBulkActionMenu(event: MouseEvent) {
    event.stopPropagation();

    this.bulkActionMenuItems = this.getBulkSecondaryActions().map(
      (action: number): MenuItem => ({
        label: this.getActionLabel(action),
        icon: this.getActionIcon(action),
        command: () => this.onBulkActionSelect(action)
      })
    );

    this.bulkActionMenu?.toggle(event);
  }

  onBulkActionSelect(event: number) {
    if (event === Settings.StatusEvent.SEND_EMAIL) return; // email has its own flow
    const ids = this.getSelectedDocumentIds();
    if (!ids.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No rows selected',
        detail: 'Please select at least one document.',
      });
      return;
    }
    this.remarkEvent = event;
    this.pendingDocumentIds = ids;
    this.remarkText = '';
    this.remarkRow = null;
    this.showRemarkModal = true;
  }

  confirmBulkRemarkAction() {
    this.isProceeding = true;
    this.loading = true
    if (this.remarkEvent == null || !this.pendingDocumentIds.length) return;
    const remark = this.remarkText.trim();
    if (this.isRemarkRequired && !remark) return;
    const label = this.remarkActionLabel;
    const count = this.pendingDocumentIds.length;
    const body = {
      document_ids: this.pendingDocumentIds,
      event: this.remarkEvent,
      remark: remark ? remark : null,
    };
    this.isSubmittingRemark = true;
    this.adminService.sendActionRemarkDocTracker(body).subscribe({
      next: (res: any) => {
        this.isProceeding = false;
        this.isSubmittingRemark = false;
        this.loadTrackerList(1);
        this.messageService.add({
          severity: 'success',
          summary: label,
          detail: res?.message || `${count} document(s) updated successfully.`,
        });
        this.closeRemarkModal();
        this.clearSelection();
        this.loading = false;
      },
      error: (err) => {
        this.isProceeding = false;
        this.isSubmittingRemark = false;
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Action failed',
          detail: err?.error?.message ?? 'Something went wrong. Please try again.',
        });
      },
    });
  }

  private getSelectedDocumentIds(): number[] {
    return (this.getSelectedRows() ?? [])
      .map((row: any) => row?.document_id ?? row?.id)
      .filter((id: any): id is number => id !== null && id !== undefined);
  }

  onSendEmail(row: any) {
    this.bulkEmailDocumentIds = [];
    this.selectedEmailDocumentIds = row?.id != null ? [row.id] : [];
    this.selectedEmailRow = [row];
    this.selectedEmailRowId = row?.id ?? null;
    this.selectedEmailRowData = row;
    this.sendEmailForm.reset({
      use_template: false,
      template_id: null,
      to: '',
      cc: '',
      subject: '',
      body: '',
      is_attachment_send: false
    });
    this.emailTemplates = [];
    this.showSendEmailModal = true;
  }

  // Bulk trigger
  onBulkSendEmail() {
    const rows = this.getSelectedRows();
    this.bulkEmailDocumentIds = rows
      .map((r: any) => r?.id)
      .filter((id: any): id is number => id != null);
    this.selectedEmailRowData = null;   // capsule in the header is row-wise only
    this.sendEmailForm.reset({
      use_template: false, template_id: null,
      to: '', cc: '', subject: '', body: '', is_attachment_send: false
    });
    this.selectedFiles = [];
    this.emailTemplates = [];
    this.showSendEmailModal = true;
  }

  closeSendEmailModal() {
    this.showSendEmailModal = false;
    this.selectedEmailRow = null;
  }

  onToggleTemplate(): void {
    const useTemplate = this.sendEmailForm.get('use_template')?.value;

    if (useTemplate) {
      this.loadEmailTemplates();
    } else {
      // toggle off → clear selection and list
      this.sendEmailForm.get('template_id')?.setValue(null);
      this.emailTemplates = [];
    }
  }

  private loadEmailTemplates(): void {
    this.loadingTemplates = true;
    const body = { get_all: true };   // adjust to whatever the list API expects
    this.adminService.getEmailTemplateList(body).subscribe({
      next: (res: any) => {
        // API returns an array directly (per your sample)
        this.emailTemplates = Array.isArray(res) ? res : (res?.results || []);
        this.loadingTemplates = false;
      },
      error: () => {
        this.emailTemplates = [];
        this.loadingTemplates = false;
      }
    });
  }

  onTemplateSelect(): void {
    const id = this.sendEmailForm.get('template_id')?.value;
    const tpl = this.emailTemplates.find(t => t.id === id);
    if (!tpl) return;
    this.sendEmailForm.patchValue({
      to: tpl.to || '',
      cc: tpl.cc || '',
      subject: tpl.subject || '',
      body: tpl.body || ''
    });
  }

  submitSendEmail() {
    if (this.sendEmailForm.invalid) {
      this.sendEmailForm.markAllAsTouched();
      return;
    }
    const documentIds: number[] = this.bulkEmailDocumentIds.length
      ? this.bulkEmailDocumentIds
      : (this.selectedEmailRowId != null
        ? [this.selectedEmailRowId]
        : []);
    if (!documentIds.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No documents',
        detail: 'No documents selected for this email.'
      });
      return;
    }
    const formValue = this.sendEmailForm.value;
    const useTemplate = formValue.use_template;
    const selectedTemplate = useTemplate
      ? this.emailTemplates.find(
        t => t.id === formValue.template_id
      )
      : null;

    const formData = new FormData();
    documentIds.forEach(id => {
      formData.append('document_ids', String(id));
    });
    formData.append('to', formValue.to ?? '');
    formData.append('cc', formValue.cc ?? '');
    formData.append('subject', formValue.subject ?? '');
    formData.append('body', formValue.body ?? '');
    formData.append(
      'is_attachment_send',
      String(this.selectedFiles.length > 0)
    );
    formData.append(
      'template_id',
      String(
        useTemplate
          ? (formValue.template_id ?? false)
          : false
      )
    );
    formData.append(
      'template_name',
      String(
        useTemplate
          ? (selectedTemplate?.template_name ?? false)
          : false
      )
    );
    this.selectedFiles.forEach(file => {
      formData.append(
        'attachment',
        file,
        file.name
      );
    });
    this.adminService.sendEmailDocTracker(formData).subscribe({
      next: (res: any) => {
        this.resetEmailForm();
        this.closeSendEmailModal();

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.message || 'Email Sent Successfully'
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            err?.error?.message ||
            'Failed to send email'
        });
      }
    });
  }

  submitRowSendEmail() {
    this.isSendingEmail = true
    if (this.sendEmailForm.invalid) {
      this.sendEmailForm.markAllAsTouched();
      return;
    }
    const formValue = this.sendEmailForm.value;
    const hasAttachments = this.selectedFiles.length > 0;
    const useTemplate = formValue.use_template;
    const selectedTemplate = useTemplate
      ? this.emailTemplates.find(t => t.id === formValue.template_id)
      : null;
    const body: any = {
      document_id: this.selectedEmailRowId,
      to: formValue.to,
      cc: formValue.cc,
      subject: formValue.subject,
      body: formValue.body,
      is_attachment_send: hasAttachments,
      template_id: useTemplate ? (formValue.template_id ?? false) : false,        // id when on, false when off
      template_name: useTemplate ? (selectedTemplate?.template_name ?? false) : false, // name when on, false when off
    };
    // this.loaderService.show();
    this.loading = true;
    this.adminService.sendEmailDocTracker(body).subscribe({
      next: (res: any) => {
        if (hasAttachments) {
          this.sendAttachments();
        }
        else {
          this.isSendingEmail = false;
          // this.loaderService.hide();
          this.loading = false;
          this.resetEmailForm();
          this.closeSendEmailModal();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Email Sent Successfully'
          });
        }
      },
      error: (err: any) => {
        // this.loaderService.hide();
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to send email'
        });
      }
    });
  }

  private sendAttachments(): void {
    this.isSendingEmail = true
    const formData = new FormData();
    formData.append('document_id', String(this.selectedEmailRowId ?? ''));
    this.selectedFiles.forEach(file => formData.append('attachments', file));
    this.adminService.sendFileAttachedDocTracker(formData).subscribe({
      next: (res: any) => {
        this.resetEmailForm();
        this.closeSendEmailModal();
        this.isSendingEmail = false
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.message || 'Email Sent Successfully'
        });
      },
      error: (err: any) => {
        this.isSendingEmail = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to send attachments'
        });
      }
    });
  }

  submitBulkSendEmail() {
    if (this.sendEmailForm.invalid) {
      this.sendEmailForm.markAllAsTouched();
      return;
    }
    if (!this.bulkEmailDocumentIds.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No documents',
        detail: 'No documents selected for this email.'
      });
      return;
    }
    const formValue = this.sendEmailForm.value;
    const useTemplate = formValue.use_template;
    const selectedTemplate = useTemplate
      ? this.emailTemplates.find(t => t.id === formValue.template_id)
      : null;
    const docIds = this.bulkEmailDocumentIds;
    const count = docIds.length;
    this.isSendingEmail = true;
    this.loading = true;
    this.uploadBulkAttachments(docIds).pipe(
      switchMap((attachmentIds: number[]) =>
        this.adminService.sendEmailDocTracker({
          document_id: docIds,
          to: formValue.to,
          cc: formValue.cc,
          bcc: null,
          subject: formValue.subject,
          body: formValue.body,
          attachment_ids: attachmentIds,
          is_attachment_send: attachmentIds.length > 0,
          template_id: useTemplate ? (formValue.template_id ?? false) : false,
          template_name: useTemplate ? (selectedTemplate?.template_name ?? false) : false,
        })
      ),
      finalize(() => {
        this.isSendingEmail = false;
        this.loading = false;
      })
    ).subscribe({
      next: (res: any) => {
        this.resetEmailForm();
        this.closeSendEmailModal();
        this.clearSelection();
        this.loadTrackerList(1);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.message || `Email sent for ${count} document(s).`
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to send email'
        });
      }
    });
  }

  private uploadBulkAttachments(documentIds: number[]): Observable<number[]> {
    if (!this.selectedFiles.length) return of([]);
    const formData = new FormData();
    formData.append('document_id', JSON.stringify(documentIds));
    this.selectedFiles.forEach(file => formData.append('attachments', file));
    return this.adminService.sendFileAttachedDocTracker(formData).pipe(
      map((res: any) => {
        const raw = res?.attachment_ids ?? res?.ids ?? res?.data ?? res?.results ?? res;
        if (!Array.isArray(raw)) return raw?.id != null ? [raw.id] : [];
        return raw
          .map((item: any) => (typeof item === 'number' ? item : item?.id))
          .filter((id: any): id is number => id != null);
      })
    );
  }

  resetEmailForm(): void {
    this.sendEmailForm.reset({ use_template: false, template_id: null });
    this.selectedFiles = [];
    this.fileError = '';
    this.emailTemplates = [];
  }

  onFilesSelected(event: any): void {
    const incoming: File[] = Array.from(event.target.files || []);
    this.fileError = '';
    const total = this.selectedFiles.length + incoming.length;
    if (total > this.maxFiles) {
      this.fileError = `You can attach a maximum of ${this.maxFiles} files.`;
      // only take what fits
      const room = this.maxFiles - this.selectedFiles.length;
      this.selectedFiles = [...this.selectedFiles, ...incoming.slice(0, room)];
    } else {
      this.selectedFiles = [...this.selectedFiles, ...incoming];
    }
    // toggle the flag based on file count
    this.sendEmailForm.get('is_attachment_send')?.setValue(this.selectedFiles.length > 0);
    event.target.value = ''; // reset input so same file can be re-picked
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.fileError = '';
    this.sendEmailForm.get('is_attachment_send')?.setValue(this.selectedFiles.length > 0);
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
    if (this.aiCopyTimer) clearTimeout(this.aiCopyTimer);
  }

  ngOnInit() {
    this.getColumnSettings();
    this.loadTrackerList(1);
    // Search Table — debounced server-side search
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(text => {
      this.serchInput = text;
      this.searchValue = text;
      this.loadTrackerList(1);
    });
  }
  isAttemptDropdownOpen = false;

  get selectedAttemptObj() {
    return this.attempts?.find(a => a.attempt === this.selectedAttempt) ?? null;
  }

  toggleAttemptDropdown() {
    this.isAttemptDropdownOpen = !this.isAttemptDropdownOpen;
  }

  closeAttemptDropdown() {
    this.isAttemptDropdownOpen = false;
  }

  clearSearchInput(inputEl?: HTMLInputElement) {
    this.searchValue = '';
    this.onClearFilter(null);   // reload the full, unfiltered list
    inputEl?.focus();           // keep the cursor in the bar
  }

}
